import { SuperAdminAnalytics } from "@/components/dashboard/superadmin/SuperAdminAnalytics"
import { Page, PageHeader } from "@/components/superadmin/kit"
import { SuperAdminLayout } from "@/components/superadmin/SuperAdminLayout"

const AnalyticsPage = () => (
  <SuperAdminLayout>
    <Page>
      <PageHeader title="Métricas" description="Crescimento de usuários, situação financeira das organizações e receita das propostas." />
      <SuperAdminAnalytics />
    </Page>
  </SuperAdminLayout>
)

export default AnalyticsPage
